import {ViewType} from "../../gd/const/views/view-type";
import {ProjectsTreeSortType} from "../space/@types";
import {TagScope} from "../tag/const";

export enum ProjectSystemType {
    PROJECT         = 1,
    WORKFOLDER      = 2,    // old
    FOLDER          = 2,    // new
    BACKLOG         = 3,
    SPRINT          = 4,
    TAG             = 5,

    PAGE            = 6,
    LINK            = 7,
    CATEGORY        = 8,
    EMBED           = 9,

    VIEW            = 10,
    REPORT_VIEW     = 11,   // it's like view but root=null & we show them in Reports Space - wait seems like not in use ???
    SECTION         = 12,
    WHITEBOARD      = 13,

    WORKSPACE       = 20,

    // PRODUCTIVITY    = 13    //


    SINGLE_VIEW_TASK_LIST   = 31,
    SINGLE_VIEW_TASK_BOARD  = 32,
    SINGLE_VIEW_GOALS       = 33,
    SINGLE_VIEW_MEETINGS    = 34,
    SINGLE_VIEW_FILES       = 35,
    SINGLE_VIEW_EXPENSES    = 36,
    SINGLE_VIEW_CHATS       = 37,
    SINGLE_VIEW_TODOS       = 38,



    DATABASE_INTERNAL       = 41,
    SUPPORT_SYSTEM          = 42,

}

// export enum ProjectAccessMode {
//     INHERITED   = 1,    // default mode - access is inherited from parent (PRIVATE)
//     EXPLICIT    = 2,    // DOES NOT inherit access - has to be set manually (!) maybe should name MANUAL ? (SHARED)
//     PUBLIC      = 3,    // always available for all company users - new one used in tags (PUBLIC)
// }


export enum ProjectAccessMode {

    INHERITANCE_NONE            = 7, // from parent - disabled, to children disabled
    INHERITANCE_PARENT          = 5, // from parent - enabled, to children disabled
    INHERITANCE_CHILDREN        = 6, // from parent - disabled, to children enabled
    INHERITANCE_PARENT_CHILDREN = 1, // default mode for folder/project - from parent - enabled, to children disabled

    // EXPLICIT                    = 2 // not in use at the moment - no inheritace i.e. DOES NOT inherite access - has to be set manually (!) maybe should name MANUAL ?
    TAG_SHARED                  = 2, // used for tags only ?

    // public should always have all company user so it doesn't meter if child inheritance on or off
    PUBLIC_INHERITANCE_CHILDREN = 3, // from parent - disabled, to children enabled, always available for all company users - new one used in tags
    PUBLIC_INHERITANCE_NONE     = 4, // from parent - disabled, to children disabled, all company user has access but has no access does not inherit to children
}

export const ProjectSystemTypeName : DictionaryStringString = {
    [ProjectSystemType.WORKSPACE]               : 'Workspace',
    [ProjectSystemType.PROJECT]                 : 'Project',
    [ProjectSystemType.FOLDER]                  : 'Folder',
    [ProjectSystemType.BACKLOG]                 : 'Backlog',
    [ProjectSystemType.SPRINT]                  : 'Sprint',
    [ProjectSystemType.TAG]                     : 'Tag',
    [ProjectSystemType.VIEW]                    : 'View',
    [ProjectSystemType.DATABASE_INTERNAL]       : 'Database',
    [ProjectSystemType.SUPPORT_SYSTEM]          : 'Support ticket system',

    [ProjectSystemType.PAGE]                    : 'Page',
    [ProjectSystemType.WHITEBOARD]              : 'Whiteboard',
    [ProjectSystemType.LINK]                    : 'Link',
    [ProjectSystemType.CATEGORY]                : 'Group',
    [ProjectSystemType.EMBED]                   : 'Embed',
    [ProjectSystemType.REPORT_VIEW]             : 'Report',
    [ProjectSystemType.SECTION]                 : 'Section',

    [ProjectSystemType.SINGLE_VIEW_TODOS]       : 'Checklist',
    [ProjectSystemType.SINGLE_VIEW_GOALS]       : 'Goals',
    [ProjectSystemType.SINGLE_VIEW_FILES]       : 'Files',
    [ProjectSystemType.SINGLE_VIEW_MEETINGS]    : 'Meetings',
    [ProjectSystemType.SINGLE_VIEW_EXPENSES]    : 'Expenses',
    [ProjectSystemType.SINGLE_VIEW_CHATS]       : 'Chats',
    [ProjectSystemType.SINGLE_VIEW_TASK_LIST]   : 'List',
    [ProjectSystemType.SINGLE_VIEW_TASK_BOARD]  : 'Board',
}

export const ProjectSystemTypeIcon = {
    [ProjectSystemType.WORKSPACE]   : 'link',
    [ProjectSystemType.PROJECT]     : 'project',
    [ProjectSystemType.FOLDER]      : 'folder',
    [ProjectSystemType.BACKLOG]     : 'archive',
    [ProjectSystemType.SPRINT]      : 'sprint',
    [ProjectSystemType.TAG]         : 'tag',

    [ProjectSystemType.PAGE]        : 'page',
    [ProjectSystemType.WHITEBOARD]  : 'whiteboard',
    [ProjectSystemType.LINK]        : 'link',
    [ProjectSystemType.CATEGORY]    : 'group',
    [ProjectSystemType.EMBED]       : 'embed',
    [ProjectSystemType.VIEW]        : 'embed',
    [ProjectSystemType.REPORT_VIEW] : 'report',  // Icon nujen!!!
    [ProjectSystemType.SECTION]     : 'section',

    [ProjectSystemType.DATABASE_INTERNAL] : 'database',  // Icon nujen!!!
    [ProjectSystemType.SUPPORT_SYSTEM]    : 'support',

    [ProjectSystemType.SINGLE_VIEW_TODOS]       : 'todo-list',
    [ProjectSystemType.SINGLE_VIEW_GOALS]       : 'goals',
    [ProjectSystemType.SINGLE_VIEW_FILES]       : 'files',
    [ProjectSystemType.SINGLE_VIEW_MEETINGS]    : 'meetings',
    [ProjectSystemType.SINGLE_VIEW_EXPENSES]    : 'expenses',
    [ProjectSystemType.SINGLE_VIEW_CHATS]       : 'chats',
    [ProjectSystemType.SINGLE_VIEW_TASK_LIST]   : 'tasks',
    [ProjectSystemType.SINGLE_VIEW_TASK_BOARD]  : 'board',
}

export enum CustomerPortalTasksAccess {
    ALL_TASKS       = 1,
    BY_CRM_CONTACT  = 2
}


export type TemplateContent = {
    customFields:   boolean
    events:         boolean
    subProjects:    boolean
    subTasks:       boolean
    tasks:          boolean
}


export const TEMPLATE_CONTENT_DEFAULT = {
    customFields:   false,
    events:         false,
    subProjects:    false,
    subTasks:       false,
    tasks:          false,
}

export const WORKSPACE_ACCESS_OPTIONS: Option[] = [
    {
        label       : "Project-based",
        value       : ProjectAccessMode.INHERITANCE_NONE,
        description : "Access is granted manually for each folder/project within the workspace.",
    },
    {
        label       : "All Projects",
        value       : ProjectAccessMode.INHERITANCE_CHILDREN,
        description : "Workspace users will have access to all resources within the workspace.",
    }
]

export const FOLDER_ACCESS_OPTIONS: Option[] = [
    {
        label       : "Inherited Access",
        value       : ProjectAccessMode.INHERITANCE_PARENT_CHILDREN,
        description : "Access is inherited from the parent folder.",
        icon        : 'i5-inherited',
    },
    {
        label       : "Custom Access",
        value       : ProjectAccessMode.INHERITANCE_CHILDREN,
        description : "Access is not inherited; grant users access manually.",
        icon        : 'i5-wrench',
    }
]

export const CUSTOM_ACCESS_OPTIONS: Option[] = [
    FOLDER_ACCESS_OPTIONS[1]
]

export type ProjectPropertiesData = {

    treatAsCatalog?         : boolean
    expenses?               : boolean
    forms?                  : any
    url?                    : any // ??? what does it do ?
    customViewType?         : ViewType

    canCreateAttachments?   : boolean
    canCreateDiscussion?    : boolean
    canCreateDocument?      : boolean
    canCreateEvent?         : boolean
    canCreateMeeting?       : boolean
    canCreateProject?       : boolean
    canCreateRequestForms?  : boolean
    canCreateTask?          : boolean
    canCreateGoal?          : boolean
    canCreateDashboard?     : boolean  // ??? is it in use

    defaultSorting?         : ProjectsTreeSortType
    defaultColorize?        : boolean

    hideResourcesIfEmpty?   : boolean   // applies to workspaces only if true will hide resaources when no items there
    showViewsGroup?         : boolean   // applies to workspaces only - auto create views dynamic pseudo section
    tagScope?               : TagScope

}
